/**
 * The contest sheets' read-side html helper, shared by contest-details and contest-invitations.
 *
 * 🚨 Returns a plain string so the `[innerHTML]` binding runs Angular's sanitiser. Do NOT
 * reintroduce `bypassSecurityTrustHtml`: this is the read side of a stored XSS (FTK-7642), and
 * sanitising at the binding is the only thing that reaches rows already in the database or written
 * straight through the API. `class` survives; `style` does not (the stored population is paste
 * residue). Single-sourced on purpose — two copies of a security contract are two things to
 * re-audit, and the sink spec (contest-html-sinks.component.spec.ts) pins one behaviour.
 */
export function contestDisplayHtml(value: any, placeholder: string): string {
    return value ? String(value) : `<span class="placeholder">${placeholder}</span>`;
}
